import React from "react";
import {styled} from "@mui/material/styles";
import Button from "@mui/material/Button";
import StyledContainer from "./_common/StyledContainer";
import StyledHeader from "./_common/StyledHeader";
import StyledSubheader from "./_common/StyledSubheader";

const StyledButton = styled(Button)(({theme}) => ({
  marginTop: theme.spacing(2),
}));

const PageRemoved = () => {
  return (
    <StyledContainer>
      <StyledHeader color="primary">
        Reports page is disabled!
      </StyledHeader>
      <StyledSubheader>
        This page has been removed by your PMC.
      </StyledSubheader>
      <StyledButton
        variant="contained"
        color="primary"
        href="/"
      >
        Go Back to Home
      </StyledButton>
    </StyledContainer>
  );
};

export default PageRemoved;
